import { useMutation } from '@tanstack/react-query';
import { createPortalSession } from '../services/api';

export const usePortalSession = () => {
  return useMutation({
    mutationFn: async (returnUrl?: string) => {
      const data = await createPortalSession(returnUrl);
      return data;
    },
    onSuccess: (data) => {
      // Redirect in the same tab to avoid popup blockers
      // (window.open in async callbacks is blocked by most browsers)
      if (data.url) {
        window.location.href = data.url;
      }
    },
    onError: (error) => {
      console.error('Error creating portal session:', error);
    }
  });
}; 